import React, { useState } from 'react';

import { List, ListItem, Typography } from '@mui/material';

import { APP_VERSION } from 'commons/env/env-vars';
import logoAlia from 'assets/icons/logo_esferas3.png';

import { styles as mobileStyles } from '../../MobileHeader/styles';
import { styles as sidebarStyles, hoverStyleHome } from '../style';

import ListItemNotification from '../ListItemNotification';
import Logout from '../assets/LogOut';

type MenuBottomVariant = 'sidebar' | 'mobile';

interface Props {
  open: boolean;
  onLogOut: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  variant?: MenuBottomVariant;
  borderTopStyle?: React.CSSProperties | string;
}

const MenuBottomSection = ({
  open,
  onLogOut,
  variant = 'sidebar',
  borderTopStyle = { borderTop: '1px solid #757A96' },
}: Props) => {
  const [openLogOut, setOpenLogOut] = useState(false);
  const bottomStyles = variant === 'mobile' ? mobileStyles : sidebarStyles;

  const borderTopSx =
    typeof borderTopStyle === 'string'
      ? { borderTop: borderTopStyle }
      : borderTopStyle;

  return (
    <List sx={bottomStyles.listBottom}>
      <ListItemNotification />
      <ListItem sx={bottomStyles.logo}>
        <img alt="logo" src={logoAlia} width={30} />
        {open ? (
          <Typography sx={bottomStyles.logoText}>Portex</Typography>
        ) : null}
      </ListItem>

      <ListItem sx={open ? bottomStyles.versionOpen : bottomStyles.version}>
        <Typography sx={bottomStyles.versionText}>
          {open ? 'Versión: ' : ''}
          {APP_VERSION}
        </Typography>
      </ListItem>

      <ListItem
        button
        sx={[
          open ? bottomStyles.logoutLight : bottomStyles.logout,
          borderTopSx,
        ]}
        onClick={onLogOut}
        onMouseEnter={() => setOpenLogOut(true)}
        onMouseLeave={() => setOpenLogOut(false)}
      >
        <Logout onHover={openLogOut} />
        <Typography
          sx={[
            open ? bottomStyles.logoutLightText : bottomStyles.homeText,
            ...(openLogOut && !open ? [hoverStyleHome] : []),
          ]}
        >
          Cerrar Sesión
        </Typography>
      </ListItem>
    </List>
  );
};

export default MenuBottomSection;
